import React from 'react'
import { Col, Row, Form, Checkbox, Button, Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import Search from '../../components/Search'
import TableLayout from '../../components/TableLayout'

const current = JSON.parse(localStorage.getItem('sucursal'))

const ProductsListContainer = () => {
    const [withPrice, setWithPrice] = React.useState(true)
    const [subsidiary, setSubsidiary] = React.useState({
        id: current ? current.id : '',
        name: current ? current.name : '',
    })

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            sorter: true,
            filtered: true,
        },

        {
            title: 'Código de barras',
            dataIndex: 'barcode',
            sorter: true,
            filtered: true,
        },
        {
            title: 'SKU',
            dataIndex: 'sku',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Nombre',
            dataIndex: 'name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Marca',
            dataIndex: 'brand.name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Tipo de producto',
            dataIndex: 'product_type.name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Costo',
            dataIndex: 'cost',
            sorter: true,
            filtered: true,
            dataType: 'money',
        },

        {
            title: 'Creación',
            dataIndex: 'created_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Actualizacíón',
            dataIndex: 'updated_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Listado de productos"
                columns={columns}
                resource="products"
                params={`&subsidiary_id=${subsidiary.id}&withPrice=${withPrice}`}
                actions={['excel', 'active', 'create', 'edit', 'show']}
                additionalActionHeader={
                    <div style={{ margin: '0px 10px' }}>
                        <Checkbox
                            checked={withPrice}
                            onChange={e => {
                                setWithPrice(e.target.checked)
                            }}
                        >
                            Producto con precio
                        </Checkbox>
                    </div>
                }
                additionalFilter={
                    <Row gutter={24}>
                        <Col lg={6} md={24} sm={24}>
                            <Form.Item label="Sucursal">
                                <Search
                                    value={subsidiary.name}
                                    placeholder="Sucursal"
                                    onSearch={value => `/api/subsidiaries?filter[active]&filter[name]=${value}`}
                                    onChange={(key, value) => {
                                        setSubsidiary(value)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                }
                additionalAction={record => {
                    return (
                        <Tooltip title="Historial" placement="top">
                            <Link to={`/products/record/${record.id}/`} style={{ marginLeft: '5px' }}>
                                <Button type="primary" shape="circle" icon="calendar" />
                            </Link>
                        </Tooltip>
                    )
                }}
            />
        </>
    )
}

export default ProductsListContainer
